export const companies = [
    {name : "Netflix", image: "netflix"},
    {name : "Disney", image: "disney"},
    {name : "HBO max", image: "hbo"},
    {name : "National GEOGRAPHIC", image: "nat"},
    {name : "Marvel", image: "marvel"},
    {name : "Star wars", image: "starwars"},
    {name : "Pixar", image: "pixar"},
]